import React from "react";
import "animate.css/animate.min.css";
import { Link } from "react-router-dom";

import styles from "./style.module.scss";

function index() {
    return (
        <div className={styles.banner}>
            {/* <h1
                className={[
                    styles.bg,
                    "animate__animated",
                    "animate__fadeInUp",
                ].join(" ")}
            >
                TOP UP LAB
            </h1> */}
            <div className={styles.content}>
                <h1 className="animate__animated animate__bounce">
                    GAME OVER
                </h1>
                <small>
                    Thanks alot for checking us. It's not easy to manage a business
                </small>
                <div className={styles.flex}>
                    <Link to="/login">
                        <button className="animate__animated animate__bounceInUp">
                            Login to withdraw your balance
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default index;
